import script from "./SimpleDrawerPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleDrawerPanel.vue?vue&type=script&setup=true&lang=ts"

import "./SimpleDrawerPanel.vue?vue&type=style&index=0&id=0487fd3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0487fd3e"]])

export default __exports__